import {useEffect} from 'react';
import Card from '../UI/Card';
import { MdOutlineCall } from "react-icons/md";
import {BsEnvelope} from 'react-icons/bs';
import {HiOutlineLocationMarker} from 'react-icons/hi';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../pages/home/home.css';

const ContactCta = () => {

useEffect(() => {
    AOS.init({
      duration: 1000, // values from 0 to 3000, with step 50ms
      delay: 50, // values from 0 to 3000, with step 50ms
      easing: 'ease-in-out-cubic', // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
    });
  }, []);

  return (
    <div className='contact_cta'>
      <div className='container contact_cta_container'>
        <div data-aos="fade-up" className="contact_cta_header">
            <h4>NEED HELP?</h4>
            <h2>We'd love to hear from you.</h2>
            <p>Contact us today for a free consultation and let us help you take back control of your property from pests.</p>
        </div>
        <div className="contact_cta_cards">
          <div data-aos="slide-right" >
            <Card className="contact_card">
              <MdOutlineCall className='contact_cta_icon contact_cta_icon_one'/>
                <h3>Contact Sales</h3>
                <p>If you have any questions, comments, or concerns, please don't hesitate to contact us.</p>
                <Link to={'https://wa.link/d9n8np'}  target='_blank' className='btn sm contact-cta-btn'>Chat with Us</Link>
            </Card>
          </div>
          <div data-aos="fade-up" >
            <Card className="contact_card">
              <HiOutlineLocationMarker className='contact_cta_icon'/>
                <h3>Location</h3>
                <ul>
                  <li>
                    <p>2nd floor Park Place,</p>
                  </li>
                  <li>
                    <p>2nd Parklands Avenue, Off Limuru rd,</p>
                  </li>
                  <li>
                    <p>Nairobi, Kenya.</p>
                  </li>
                </ul>
            </Card>
          </div>
          <div data-aos="slide-left" >
            <Card className="contact_card">
              <BsEnvelope className='contact_cta_icon'/>
                <h3>Email Us</h3>
                <p>We look forward to hearing from you.</p>
                <Link to="./contact" className='btn sm contact-cta-btn'>Email Us</Link>
            </Card>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactCta